import { supabase } from '@/lib/supabase'

export async function resetAccountOwnerPassword(accountId: string, newPassword: string, mustChange = true): Promise<void> {
  if (!accountId) throw new Error('Conta inválida')
  if (!newPassword || newPassword.length < 8) throw new Error('A senha deve ter pelo menos 8 caracteres')
  const hasUpper = /[A-Z]/.test(newPassword)
  const hasSpecial = /[^A-Za-z0-9]/.test(newPassword)
  if (!hasUpper || !hasSpecial) throw new Error('A senha deve conter letra maiúscula e caractere especial')
  const { error, data } = await (supabase.functions as any).invoke('admin-reset-user-password', { body: { accountId, password: newPassword, must_change_password: !!mustChange } })
  if (error) {
    const err: any = error
    try {
      const resp: Response | undefined = err?.context?.response
      if (resp) {
        const status = (resp as any)?.status as number | undefined
        let text = ''
        try { text = await (resp.clone ? resp.clone().text() : resp.text()) } catch {}
        const t = (text || '').toLowerCase()
        if (status === 401) throw new Error('Não autenticado. Faça login novamente.')
        if (status === 403) throw new Error('Sem permissão: apenas master pode alterar senha do cliente.')
        if (status === 404 || t.includes('owner_not_found')) throw new Error('Titular da conta não encontrado para esta conta.')
        if (t.includes('weak_password')) throw new Error('Senha não atende aos requisitos mínimos')
        if (t) throw new Error(text)
      }
    } catch {}
    throw new Error(String(err?.message || err))
  }
  const payload = (Array.isArray(data) ? data[0] : data) as any
  if (payload?.error) throw new Error(String(payload.error))
}
